import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconContentBlock20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconContentBlock20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.25 9h-.75V2.5h5A2.5 2.5 0 0 1 19 5v4zm4.25-5H13v3.5h4.5V5a1 1 0 0 0-1-1m-8.25 6.75V6.5H3.498a1 1 0 0 0-1 1v3.25zm0 1.5H2.498v3.25a1 1 0 0 0 1 1H8.25zm1.5 0v4.25h4.748a1 1 0 0 0 1-1v-3.25zm7.248 0v3.25a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5v-8a2.5 2.5 0 0 1 2.5-2.5H9.75v5.75H17v1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconContentBlock20);
